import * as React from 'react';
import * as ReactDOM from 'react-dom';
// 无全局变量的情况
if (!window.React) {
    window.React = React;
}
if (!window.ReactDOM) {
    window.ReactDOM = ReactDOM;
}
export * from './view';
import CNIntelliAssistent from './view';
export default CNIntelliAssistent;
